<template>
  <div>
    <div v-if="loading" class="title-section-content">
      <h3>Carregando...</h3>
    </div>

    <div v-else>
      <modal-vue class="col-lg-12" v-if="showModal" @close="showModal = false">
        <h3 slot="header">Vídeos</h3>

        <div slot="body">
          <div
            class="modules-content"
            style="overflow-y: scroll;padding-right:0px;padding-left:0px;"
          >
            <div class="module-item">
              <ul class="lessons-list">
                <li class="lesson-subtitle custom-grid-modal">
                  <span class="lesson-title">Título</span>
                  <span class="lesson-title">Identificador</span>
                  <span class="lesson-option"></span>
                </li>

                <li class="lesson custom-grid-modal">
                  <div class="lesson-title control-group">
                    <div class="controls">
                      <input id="name" type="text" v-model="newVideo.title" class="form-control" />
                    </div>
                  </div>
                  <div class="lesson-title control-group">
                    <div class="controls">
                      <input
                        id="name"
                        type="text"
                        v-model="newVideo.identifier"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <span class="lesson-option">
                    <button @click="addVideo(newVideo)" class="btn btn-success">
                      Adicionar
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                </li>
                <!-- <p v-if="loading" class="input-group-addon">
          <i class="fa fa-spinner fa-spin text-info"></i>
                </p>-->

                <draggable
                  :key="listKey"
                  v-model="videos"
                  group="people"
                  @start="drag=true"
                  @end="testDrag()"
                >
                  <div v-for="v in videos" :key="v.id">
                    <li v-if="!v.deleted" class="lesson custom-grid-modal">
                      <span class="lesson-title">{{v.title}}</span>
                      <span class="lesson-title">{{v.identifier}}</span>
                      <span class="lesson-option">
                        <button @click="removeVideo(v)" class="btn btn-danger">
                          Remover
                          <i class="fa fa-trash"></i>
                        </button>
                      </span>
                    </li>
                  </div>
                </draggable>
              </ul>
            </div>
          </div>
        </div>

        <div slot="footer">
          <lms-button @click="saveVideos()" :loading="savingVideos">Salvar</lms-button>
          <!-- <button class="btn btn-default" @click="saveVideos()">Salvar</button> -->
          <button class="btn btn-default" @click="showModal = false;lessonId = 0;">Cancelar</button>
        </div>
      </modal-vue>

      <a
        v-if="addNewModule==false"
        v-on:click="addNewModule=true"
        style="margin-bottom:15px;"
        class="form-control btn btn-default-lms"
      >
        Adicionar módulo
        <i class="fa fa-plus"></i>
      </a>
      <a
        v-else
        v-on:click="addNewModule=false"
        style="margin-bottom:15px;"
        class="form-control btn btn-default-lms"
      >
        Cancelar
        <i class="fa fa-plus"></i>
      </a>

      <div v-if="addNewModule" style="padding-left:0px;padding-right:0px;" class="modules-content">
        <div class="module-item">
          <div class="title-content" style="grid-gap:0;grid-template-columns:1fr 1fr 15rem">
            <div style="margin-right:15px;" class="module-title control-group">
              <label class="control-label" for="name">Nome</label>

              <div class="controls">
                <input id="name" v-model="newModule.name" type="text" class="form-control" />
              </div>
            </div>

            <div style="margin-right:15px;" class="module-title control-group">
              <label class="control-label" for="name">Descrição</label>

              <div class="controls">
                <input id="name" v-model="newModule.description" type="text" class="form-control" />
              </div>
            </div>

            <!-- <h3 class="module-title">Módulo</h3> -->
            <a
              v-on:click="addModule()"
              style="margin-top:auto;"
              class="form-control btn btn-default-lms"
            >
              Salvar
              <i class="fa fa-plus"></i>
            </a>

            <div>
              <span class="module-progress loading-placeholder"></span>
            </div>
          </div>
        </div>
      </div>

      <draggable
        :key="listKey"
        v-model="modules"
        group="people"
        @start="drag=true"
        @end="testDrag()"
      >
        <div
          v-for="module in modules"
          v-bind:key="module.id"
          style="padding-left:0px;padding-right:0px;"
          class="modules-content"
        >
          <div class="module-item">
            <div class="title-content" style="grid-gap:0px 10px;">
              <h3 class="module-title">{{module.name}}</h3>

              <a
                v-if="addNewLesson!=module.id"
                v-on:click="addNewLesson=module.id"
                class="form-control btn btn-default-lms"
              >
                Adicionar aula
                <i class="fa fa-plus"></i>
              </a>
              <a
                v-else
                v-on:click="newLesson = {};addNewLesson=0;"
                class="form-control btn btn-default-lms"
              >
                Cancelar
                <i class="fa fa-times-circle"></i>
              </a>

              <a
                @click="removeModule(module.id)"
                style="margin-right:5px !important;"
                class="form-control btn btn-danger-lms"
              >
                Remover
                <i class="fa fa-trash"></i>
              </a>

              <div>
                <span class="module-progress loading-placeholder"></span>
              </div>
            </div>

            <li class="lesson-subtitle custom-grid">
              <span class="lesson-title">Vídeos</span>
              <span class="lesson-title">Aula</span>
              <span class="lesson-description">Professor</span>
              <span class="lesson-description">Identificador</span>
              <span class="lesson-option"></span>
            </li>

            <ul class="lessons-list">
              <li v-if="addNewLesson==module.id" class="lesson custom-grid">
                <span class="lesson-option"></span>
                <div class="lesson-title control-group">
                  <label class="control-label" for="name">Título *</label>

                  <div class="controls">
                    <input id="name" type="text" v-model="newLesson.title" class="form-control" />
                  </div>
                </div>

                <div class="lesson-title control-group">
                  <label class="control-label" for="name">Professor *</label>

                  <div class="controls">
                    <select v-model="newLesson.teacher_id" id="teacher" class="form-control">
                      <option disabled value>Escolha um professor</option>
                      <option
                        v-for="teacher in teachers"
                        v-bind:key="teacher.userId"
                        v-bind:value="teacher.userId"
                      >{{teacher.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="lesson-title control-group">
                  <label class="control-label" for="name">Identificador *</label>

                  <div class="controls">
                    <input
                      id="name"
                      type="text"
                      v-model="newLesson.identifier"
                      class="form-control"
                    />
                  </div>
                </div>

                <span style="margin-top:auto;" class="lesson-option">
                  <a
                    :disabled="savingLesson"
                    v-on:click="addLesson(module)"
                    href="#"
                    role="button"
                  >Adicionar</a>
                </span>
              </li>

              <li v-for="lesson in module.lessons" :key="lesson.id" class="lesson custom-grid">
                <span class="lesson-title">
                  <link-button
                    @click="loadVideos(lesson.id)"
                    :loading="lessonId == lesson.id"
                  >{{lesson.videos}} vídeos</link-button>
                </span>
                <span class="lesson-title">{{lesson.title}}</span>
                <span class="lesson-description">{{lesson.teacherName}}</span>
                <span class="lesson-description">{{lesson.identifier}}</span>
                <span class="lesson-option">
                  <a v-on:click="removeLesson(lesson.id)" href="#">Remover</a>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </draggable>
    </div>

    <lms-button
      v-if="modulesOrderChanged"
      class="float btn-success"
      @click="saveModulesOrder()"
      :loading="savingModules"
    >Salvar alterações</lms-button>
  </div>
</template>

<style scoped>
.custom-link {
  padding: 0px;
}
.custom-grid {
  grid-template-columns: 1fr 1fr 1fr 1fr 0.75fr !important;
}
.custom-grid-modal {
  grid-template-columns: 1fr 1fr 0.75fr !important;
}
* {
  padding: 0;
  margin: 0;
}

.float {
  position: fixed;
  height: 60px;
  bottom: 40px;
  right: 40px;
  color: #fff;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.my-float {
  margin-top: 22px;
}
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: ["course", "modules", "teachers"],
  data() {
    return {
      savingModules: false,
      modulesOrderChanged: false,
      savingVideos: false,
      lessonId: 0,
      listKey: 0,
      newVideo: {},
      videos: [],
      showModal: false,
      showVideos: 0,
      savingLesson: false,
      loading: false,
      addNewModule: false,
      addNewLesson: 0,
      newModule: {},
      newLesson: {},
      selectedFile: null
    };
  },
  computed: {},
  components: {},
  methods: {
    loadVideos(lessonId) {
      this.lessonId = lessonId;
      const path = this.$global.endpoint + "/video/getall";

      axios
        .post(path, {
          lessonId: lessonId
        })
        .then(res => {
          this.videos = res.data;
          this.showModal = true;
        })
        .catch(error => {
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    saveVideos() {
      this.savingVideos = true;
      const path = this.$global.endpoint + "/video/save";

      axios
        .post(path, {
          videos: this.videos,
          lessonId: this.lessonId
        })
        .then(res => {
          this.showModal = false;
          this.lessonId = 0;
          this.savingVideos = false;
          this.$emit("changed");
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Vídeos cadastrados"
          });
        })
        .catch(error => {
          this.savingVideos = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    removeVideo(video) {
      video.deleted = true;
      this.listKey += 1;
    },
    testDrag() {
      console.log(this.videos);
    },
    addVideo(video) {
      this.videos.push(video);
      this.newVideo = {};
    },
    addLesson(module) {
      this.savingLesson = true;
      this.newLesson.module_id = module.id;

      const path = this.$global.endpoint + "/lesson/save";
      axios
        .post(path, { lesson: this.newLesson })
        .then(res => {
          this.$emit("changed");
          this.newLesson = {};
          this.addNewLesson = 0;
          this.savingLesson = false;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Aula cadastrada"
          });
        })
        .catch(error => {
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    addModule() {
      this.newModule.course_id = this.course.id;
      const path = this.$global.endpoint + "/module/save";
      axios
        .post(path, { module: this.newModule })
        .then(res => {
          this.$emit("changed");
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Módulo adicionado com sucesso"
          });
        })
        .catch(error => {
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    removeLesson(lessonId) {
      const path = this.$global.endpoint + "/lesson/remove";
      axios
        .post(path, { lessonId: lessonId })
        .then(res => {
          this.$emit("changed");
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Aula removida com sucesso"
          });
        })
        .catch(error => {
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    testDrag() {
      this.modulesOrderChanged = true;
      this.listKey += 1;
    },
    saveModulesOrder() {
      this.savingModules = true;

      const path = this.$global.endpoint + "/module/saveorder";
      axios
        .post(path, { modules: this.modules })
        .then(res => {
          this.$emit("changed");
          this.modulesOrderChanged = false;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Ordem dos módulos atualizada"
          });
        })
        .catch(error => {
          console.error(error);
          this.modulesOrderChanged = false;
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    removeModule(moduleId) {
      const path = this.$global.endpoint + "/module/remove";
      axios
        .post(path, { moduleId: moduleId })
        .then(res => {
          this.$emit("changed");
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Módulo removido com sucesso"
          });
        })
        .catch(error => {
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    }
  },
  mounted() {}
};
</script>
